<template>
    <div class="bg-wrap">
        <Banner></Banner>
        <div class="content">
            <div class="pdf" @click="toZoom">
                <pdf
                        :page="1"
                        :src="pdf"
                        @progress="loadedRatio = $event"
                        @num-pages="pageTotalNum=$event"
                        @loaded="loaded"
                        style="width: 100px"
                ></pdf>
                <label class="zoom" @click="toZoom"></label>
            </div>
            <div class="title">
                <label>评审</label>
                <span><a :href="pdf" download="病例.pdf">下载</a></span>
            </div>
            <div class="score-wrap">
                <div class="item">
                    <div class="item-1">
                        <span class="info">基本信息（10分）</span>
                        <label class="fill"></label>
                        <input type="number" class="score" readonly @click="scoreItem(1)" v-model="judgeScore.baseInfoScore">
                        <span class="item-2">分</span>
                    </div>
                    <div class="item-2">
                        <ul class="row">
                            <li>患者基本信息</li>
                            <li>主诉</li>
                            <li>现病史 </li>
                            <li>家族史</li>
                            <li>既往史及个人史</li>
                        </ul>
                    </div>
                </div>
                <div class="item">
                    <div class="item-1">
                        <span class="info">检查及诊断（30分）</span>
                        <label class="fill"></label>
                        <input type="number" class="score" readonly @click="scoreItem(2)" v-model="judgeScore.checkScore">
                        <span class="item-2">分</span>
                    </div>
                    <div class="item-2">
                        <ul>
                            <li>相关检查及诊断性评估</li>
                            <li>心血管风险评估</li>
                            <li>临床诊断及鉴别诊断</li>
                            <li>病历临床特点总结</li>
                        </ul>
                    </div>
                </div>
                <div class="item">
                    <div class="item-1">
                        <span class="info">规范治疗（30分）</span>
                        <label class="fill"></label>
                        <input type="number" class="score" @click="scoreItem(3)" readonly v-model="judgeScore.treatScore">
                        <span class="item-2">分</span>
                    </div>
                    <div class="item-2">
                        <ul>
                            <li>血压目标</li>
                            <li>生活方式干预</li>
                            <li>药物治疗（是否使用SPC治疗）</li>
                            <li>注意事项</li>
                        </ul>
                    </div>
                </div>
                <div class="item">
                    <div class="item-1">
                        <span class="info">随访及反馈（15分）</span>
                        <label class="fill"></label>
                        <input type="number" class="score" @click="scoreItem(4)" readonly v-model="judgeScore.feedbackScore">
                        <span class="item-2">分</span>
                    </div>
                    <div class="item-2">
                        <ul>
                            <li>依从性</li>
                            <li>随访内容</li>
                            <li>治疗反馈</li>
                        </ul>
                    </div>
                </div>
                <div class="item">
                    <div class="item-1">
                        <span class="info">病例讨论及总结分享（15分）</span>
                        <label class="fill"></label>
                        <input type="number" class="score" @click="scoreItem(5)" readonly v-model="judgeScore.shareScore">
                        <span class="item-2">分</span>
                    </div>
                    <div class="item-2">
                        <ul>
                            <li>病例闪光点展示</li>
                        </ul>
                    </div>
                </div>
            </div>
<!--            <div class="score-wrap">-->
<!--                <span class="title-1">病例演讲部分</span>-->
<!--                <div class="item">-->
<!--                    <div class="item-1">-->
<!--                        <span class="info">表达能力（20分）</span>-->
<!--                        <label class="fill"></label>-->
<!--                        <input type="number" class="score" @click="scoreItem(6)" readonly v-model="judgeScore.expressScore">-->
<!--                        <span class="item-2">分</span>-->
<!--                    </div>-->
<!--                    <div class="item-2">-->
<!--                        <ul >-->
<!--                            <li>语言清楚、通顺、逻辑性强，专业术语使用准确、规范</li>-->
<!--                        </ul>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="item">-->
<!--                    <div class="item-1">-->
<!--                        <span class="info">视频时间（10分）</span>-->
<!--                        <label class="fill"></label>-->
<!--                        <input type="number" class="score" @click="scoreItem(7)" readonly v-model="judgeScore.timeScore">-->
<!--                        <span class="item-2">分</span>-->
<!--                    </div>-->
<!--                    <div class="item-2">-->
<!--                        <ul >-->
<!--                            <li>严格掌握演讲时间，演讲视频时间20-30min</li>-->
<!--                        </ul>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
            <div class="all-score">
                <span>总分</span>
                <input class="i-all-score" type="text" readonly v-model="score">
            </div>
            <div class="suggestion">
                <div class="title">
                    <span>评审意见</span>
                </div>
                <div class="input">
                    <textarea placeholder="请填写评语，每位选手评语不少于100字" v-model="judgeScore.suggestion"></textarea>
                    <div class="font-number" >
                        <span>{{judgeScore.suggestion.length}}/100</span>
                    </div>
                </div>
                <div class="submit" @click="toSubmit">
                    <label>提交</label>
                </div>
            </div>
        </div>
        <Popup :values="values" @valueCheck="valueCheck"></Popup>
    </div>

</template>

<script>
    import Banner from "@/components/ksd/fragment/Banner";
    import pdf from 'vue-pdf'
    import Popup from "@/components/ksd/fragment/Popup";
    import {ksdJudgeCaseScore} from "@/assets/js/api";
    import {Indicator,MessageBox} from "mint-ui";

    export default {
        name: "JudgeScore",
        data(){
            return{
                pdf:this.$route.query.pdf,
                values:[],
                id:0,
                index:"",
                score:"",
                judgeScore:{
                    suggestion:"",
                    baseInfoScore:"",
                    checkScore:"",
                    treatScore:"",
                    feedbackScore:"",
                    shareScore:"",
                    expressScore:"",
                    timeScore:"",
                    docId:this.$route.query.docId,
                    id:this.$route.query.id,
                    judgeId:this.$store.state.ksd_judgeId,

                }
            }
        },
        components:{
            Banner,
            pdf,
            Popup
        },
        mounted(){
          this.loading()
        },
        methods:{
            loading(){
                Indicator.open({
                    text: '加载中',
                    spinnerType: 'fading-circle'
                });
            },
            loaded(){
                Indicator.close()
            },
            toSubmit(){
                if(this.judgeScore.baseInfoScore==""||this.judgeScore.checkScore==""|this.judgeScore.treatScore==""||this.judgeScore.feedbackScore==""||this.judgeScore.shareScore==""){
                    this.$toast("含有未打分项")
                    return
                }
                if(this.judgeScore.suggestion==""){
                    this.$toast("请填写评审意见")
                    return;
                }
                if(this.judgeScore.suggestion.length<100){
                    this.$toast("评审意见未满100字")
                    return;
                }
                this.submit(this.judgeScore)
            },
            toZoom(){
                this.$router.push({path:"pdf",query:{url:this.pdf}})
            },
            valueCheck(value){
                switch (this.index) {
                    case 1:
                        this.judgeScore.baseInfoScore = value
                        break;
                    case 2:
                        this.judgeScore.checkScore = value
                        break;
                    case 3:
                        this.judgeScore.treatScore = value
                        break;
                    case 4:
                        this.judgeScore.feedbackScore = value
                        break;
                    case 5:
                        this.judgeScore.shareScore = value
                        break;
                    case 6:
                        this.judgeScore.expressScore = value
                        break;
                    case 7:
                        this.judgeScore.timeScore = value
                        break;
                }

            },
            scoreItem(index){
                this.index = index
                let score = 10
                switch (index) {
                    case 1:
                        score=10
                        break;
                    case 2:
                        score=30
                        break;
                    case 3:
                        score=30
                        break;
                    case 4:
                        score=15
                        break;
                    case 5:
                        score=15
                        break;
                }

                this.values=[];
                for(let i=score;i>0;i--){
                    this.values.push(i)
                }
            },
            getAllScore(){
                this.score =0;
                if(this.judgeScore.baseInfoScore!=""){
                    this.score+=this.judgeScore.baseInfoScore
                }
                if(this.judgeScore.treatScore!=""){
                    this.score+=this.judgeScore.treatScore
                }
                if(this.judgeScore.checkScore!=""){
                    this.score+=this.judgeScore.checkScore
                }
                if(this.judgeScore.feedbackScore!=""){
                    this.score+=this.judgeScore.feedbackScore
                }
                if(this.judgeScore.shareScore!=""){
                    this.score+=this.judgeScore.shareScore
                }
                if(this.judgeScore.timeScore!=""){
                    this.score+=this.judgeScore.timeScore
                }
                if(this.judgeScore.expressScore!=""){
                    this.score+=this.judgeScore.expressScore
                }
            },
            async submit(judgeScore){
                const res = await ksdJudgeCaseScore({judgeScore})
                let _this = this
                if(res.data.success){
                    MessageBox.confirm(
                        '',
                        {
                            message:res.data.data,
                            showCancelButton:false
                        }
                    ).then(() => {
                        _this.$router.replace("judgeSuccess")
                    });


                }else{
                    this.$toast(res.data.message)
                }
                console.log(res)
            }
        },
        watch:{
            judgeScore:{
                deep: true,
                handler:function () {
                    this.getAllScore()
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .bg-wrap {
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        overflow: scroll;
    }
    .bottom{
        display: flex;
        justify-content: flex-end;
        margin-bottom: -50px;
        img{
            width: 350px;
            height: 344px;
        }
    }
    .content{
        width: 100%;
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        .pdf{
            width: 90%;
            height: 200px;
            background: #e0e0e0;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            .zoom{
                position: absolute;
                display: block;
                width: 28px;
                height: 28px;
                background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/icon_zoom_1.png") no-repeat;
                background-size: cover;
                bottom: 10px;
                right: 10px;
            }
        }
        .title{
            width: 100%;
            text-align: left;
            margin: 10px;
            font-size: 18px;
            display: flex;
            justify-content: space-between;
            label{
                background: #156098;
                color: #FFF;
                padding: 3px 20px;
            }
            span{
                color: #156098;
                margin-right: 25px;
                font-size: 14px;
                text-decoration: underline;
            }

        }
        .score-wrap{
            width: 90%;
            display: flex;
            flex-flow: column;
            align-items: flex-start;
            .title-1{
                color: #156098;
                font-weight: bold;
                font-size: 16px;
                margin-top: 2px;
                margin-bottom: 12px ;
            }
            .item{
                margin-bottom: 10px;
                width: 100%;
            }
            .item-1{
                margin-bottom: 10px;
                background: #e0e0e0;
                text-align: left;
                border-left: #156098 3px solid;
                padding: 2px 0;
                border-radius: 3px;
                display: flex;
                flex-flow: row nowrap;
                font-size: 15px;
                .info{
                    margin-left: 5px;
                    margin-top: 3px;
                }
                .fill{
                    flex-grow: 1;
                }
                .score{
                    width: 50px;
                }
            }
        }
        .all-score{
            width: 100%;
            margin-right: 10%;
            margin-bottom: 10px;
            text-align: right;
            color: #156098;
            font-size: 18px;
            font-weight: bold;
            input{
                width: 80px;
            }
        }
        .suggestion{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            width: 90%;
            .title{
                color: #156098;
                font-size: 16px;
                font-weight: bold;
                margin-left: 0;
            }
            .input{
                position: relative;
            }
            .input textarea{
                width: 100%;
                height: 150px;
                outline: none;
                border: none;
                background: #FFF;
                padding: 0;
                font-size: 15px;
            }
            .font-number{
                position: absolute;
                bottom: 10px;
                right: 10px;
                font-size: 15px;
            }
            .submit{
                width: 100%;
                background: #156098;
                color: #FFF;
                margin-top: 10px;
                padding: 5px 0;
                font-size: 16px;
                border-radius: 5px;
                margin-bottom: 30px;
            }
        }
    }

    ul{
        text-align: left;
        /*margin: 0;*/
        padding: 0;
        font-size: 15px;
        margin-top: 0;
        margin-left: 30px;
    }

    li{
        text-indent: -5px;
        margin-bottom: 5px;
        padding: 0;
    }

    .row{
        li{
            float: left;
            margin-right: 20px;
            text-indent: -5px;
        }
    }

    input{
        border: none;
        outline: none;
        background: transparent;
        border-radius: 0;
        border-bottom: #156098 1px solid;
        text-indent: 15px;
    }

    .i-all-score{
        font-size: 18px;
    }



</style>
